export default {
	state: {
		previousPage: "",
		page: ""
	},

	actions: {
		show(actionContext, page) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("show", page)

					window.scrollTo(0, 0)

					resolve()
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		show(state, page) {
			state.previousPage = state.page
			state.page = page
		}
	},

	namespaced: true
}